import React from 'react';
import { FaMapMarkerAlt, FaConciergeBell, FaWifi, FaLeaf, FaCamera } from 'react-icons/fa';

const reasons = [
  { icon: <FaMapMarkerAlt />, title: 'Perfect Location', desc: 'Quiet, secure, and surrounded by nature.' },
  { icon: <FaConciergeBell />, title: 'Great Service', desc: 'Friendly staff dedicated to your comfort.' },
  { icon: <FaWifi />, title: 'Modern Amenities', desc: 'Everything you need for business or leisure.' },
  { icon: <FaCamera />, title: 'Unique Experiences', desc: 'Nature walks, fine dining, and more.' },
  { icon: <FaLeaf />, title: 'Eco-Friendly Practices', desc: 'Committed to protecting the environment.' },
];

const WhyChooseUs = () => {
  return (
    <section className="py-20 bg-gray-50">
      <div className="container mx-auto px-4">
        <h2 className="text-4xl font-bold text-center mb-4 text-gray-800">Why Choose Us</h2>
        <p className="text-center text-gray-600 mb-12 max-w-3xl mx-auto">
          Tuneza Lodge’s competitive advantage lies in its ideal location, providing a serene, secure, and spacious setting
          with breathtaking scenery, coupled with exceptional customer service and modern facilities.
        </p>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-6">
          {reasons.map((item, index) => (
            <div key={index} className="text-center bg-white p-6 rounded-lg shadow-md border-b-4 border-gold-500">
              <div className="text-4xl text-gold-500 mb-3 flex justify-center">{item.icon}</div>
              <h3 className="font-semibold text-lg mb-2">{item.title}</h3>
              <p className="text-gray-600 text-sm">{item.desc}</p>
            </div>
          ))}
        </div>

        <div className="mt-12 text-center max-w-3xl mx-auto bg-white p-8 rounded-lg shadow-lg border-l-4 border-gold-500">
          <p className="text-xl text-gray-700 italic">
            "At Tuneza Lodge, we guarantee a memorable and personalized stay for every guest. Whether here for a business conference,
            a relaxing getaway, or any special occasion, Tuneza Lodge ensures an outstanding stay that exceeds expectations."
          </p>
        </div>
      </div>
    </section>
  );
};

export default WhyChooseUs;